__turbopack_context__.v({
  "auditNotice": "login-module__rMv5LG__auditNotice",
  "brandingContent": "login-module__rMv5LG__brandingContent",
  "brandingSide": "login-module__rMv5LG__brandingSide",
  "brandingSubtitle": "login-module__rMv5LG__brandingSubtitle",
  "brandingText": "login-module__rMv5LG__brandingText",
  "brandingTitle": "login-module__rMv5LG__brandingTitle",
  "ctaBtn": "login-module__rMv5LG__ctaBtn",
  "divider": "login-module__rMv5LG__divider",
  "errorBanner": "login-module__rMv5LG__errorBanner",
  "fade-up": "login-module__rMv5LG__fade-up",
  "formHeader": "login-module__rMv5LG__formHeader",
  "formSide": "login-module__rMv5LG__formSide",
  "formWrapper": "login-module__rMv5LG__formWrapper",
  "hammer": "login-module__rMv5LG__hammer",
  "inputField": "login-module__rMv5LG__inputField",
  "inputGrid": "login-module__rMv5LG__inputGrid",
  "inputGroup": "login-module__rMv5LG__inputGroup",
  "loginContainer": "login-module__rMv5LG__loginContainer",
  "loginForm": "login-module__rMv5LG__loginForm",
  "logoIcon": "login-module__rMv5LG__logoIcon",
  "mesh-flow": "login-module__rMv5LG__mesh-flow",
  "overlay": "login-module__rMv5LG__overlay",
  "planBadge": "login-module__rMv5LG__planBadge",
  "socialBtn": "login-module__rMv5LG__socialBtn",
  "socialGrid": "login-module__rMv5LG__socialGrid",
  "submitBtn": "login-module__rMv5LG__submitBtn",
  "switchMode": "login-module__rMv5LG__switchMode",
});
